import React, { useEffect, useState } from "react";
import {
  PDFViewer,
  Document,
  Page,
  View,
  Text,
  Image,
} from "@react-pdf/renderer";
import axios from "axios";
import config from "../../config";

const PdfReport = ({ groupedData, schooldata }) => (
  <Document>
    {Object.entries(groupedData).map(
      ([challanNo, { full_data, summary_data }], index) => {
        const filteredGenderRows = summary_data.gender_summary.filter((row) =>
          Object.entries(row).some(
            ([key, value]) => key !== "GENDER" && value > 0
          )
        );

        const availableColumns = [
          "EX_REGULAR",
          "REGULAR",
          "PRIVATE",
          "BETTERMENT",
          "QUALIFYING",
        ].filter((key) =>
          summary_data.gender_summary.some((row) => row[key] > 0)
        );

        const tableHeaders = ["GENDER", ...availableColumns, "TOTAL"];

        return (
          <Page
            size="A4"
            orientation="landscape"
            style={{ padding: 15, fontSize: 10, fontFamily: "Helvetica" }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 10,
              }}
            >
              <Image
                src="../assets/images/jac.png"
                style={{
                  width: 35,
                  height: 35,
                  marginRight: 10,
                }}
              />
              <View style={{ flex: 1, textAlign: "center" }}>
                <Text style={{ fontSize: 12, fontWeight: "bold" }}>
                  JHARKHAND ACADEMIC COUNCIL, RANCHI
                </Text>
                <Text
                  style={{ marginTop: 4, fontSize: 10, fontWeight: "bold" }}
                >
                  List Of Examinees Students For Intermediate Examination 2026
                  (Annual)
                </Text>
              </View>
            </View>
            <View
              style={{
                flexDirection: "row",
                paddingBottom: 2,
                marginBottom: 2,
              }}
            >
              <View
                style={{
                  width: "20%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  gap: 4,
                }}
              >
                <view style={{ width: "40%" }}>
                  <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                    School Code
                  </Text>
                </view>
                <View
                  style={{
                    borderBottomWidth: 1,
                    borderColor: "black",
                    width: "52%",
                  }}
                >
                  <Text style={{ fontSize: 10, textAlign: "left" }}>
                    {schooldata.SCHOOL_CODE}
                  </Text>
                </View>
              </View>

              <View
                style={{
                  width: "40%",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  gap: 4,
                }}
              >
                <View style={{ width: "20%" }}>
                  <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                    School Name
                  </Text>
                </View>
                <View
                  style={{
                    borderBottomWidth: 1,
                    borderColor: "black",
                    width: "75%",
                  }}
                >
                  <Text style={{ fontSize: 10, textAlign: "left" }}>
                    {schooldata.SCHOOL_NAME}
                  </Text>
                </View>
              </View>

              <View
                style={{
                  width: "20%",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  gap: 4,
                }}
              >
                <View style={{ width: "25%" }}>
                  <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                    District
                  </Text>
                </View>
                <View
                  style={{
                    borderBottomWidth: 1,
                    borderColor: "black",
                    width: "70%",
                  }}
                >
                  <Text style={{ fontSize: 10, textAlign: "left" }}>
                    {schooldata.DISTRICT}
                  </Text>
                </View>
              </View>
              <View
                style={{
                  width: "20%",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  gap: 4,
                }}
              >
                <View style={{ width: "30%" }}>
                  <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                    Category
                  </Text>
                </View>
                <View
                  style={{
                    borderBottomWidth: 1,
                    borderColor: "black",
                    width: "65%",
                  }}
                >
                  <Text style={{ fontSize: 10, textAlign: "left" }}>
                    {schooldata.CATEGORY || " "}
                  </Text>
                </View>
              </View>
            </View>

            <View
              style={{
                flexDirection: "row",
                paddingBottom: 2,
                marginBottom: 2,
              }}
            >
              {/* Sub-Division */}
              <View
                style={{
                  width: "20%",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  gap: 4,
                }}
              >
                <View style={{ width: "40%" }}>
                  <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                    Sub-Division
                  </Text>
                </View>
                <View
                  style={{
                    borderBottomWidth: 1,
                    borderColor: "black",
                    width: "55%",
                  }}
                >
                  <Text style={{ fontSize: 10 }}>
                    {schooldata.DIVISION_NAME}
                  </Text>
                </View>
              </View>

              {/* Block */}
              <View
                style={{
                  width: "40%",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  gap: 4,
                }}
              >
                <View style={{ width: "10%" }}>
                  <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                    Block
                  </Text>
                </View>
                <View
                  style={{
                    borderBottomWidth: 1,
                    borderColor: "black",
                    width: "85%",
                  }}
                >
                  <Text style={{ fontSize: 10 }}>{schooldata.BLOCK_NAME}</Text>
                </View>
              </View>

              {/* Post Office */}
              <View
                style={{
                  width: "20%",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  gap: 4,
                }}
              >
                <View style={{ width: "35%" }}>
                  <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                    Post Office
                  </Text>
                </View>
                <View
                  style={{
                    borderBottomWidth: 1,
                    borderColor: "black",
                    width: "60%",
                  }}
                >
                  <Text style={{ fontSize: 10 }}>{schooldata.POST_OFFICE}</Text>
                </View>
              </View>

              {/* PIN */}
              <View
                style={{
                  width: "20%",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  gap: 4,
                }}
              >
                <View style={{ width: "20%" }}>
                  <Text style={{ fontSize: 10, fontWeight: "bold" }}>PIN</Text>
                </View>
                <View
                  style={{
                    borderBottomWidth: 1,
                    borderColor: "black",
                    width: "75%",
                  }}
                >
                  <Text style={{ fontSize: 10 }}>
                    {schooldata.PIN_CODE || " "}
                  </Text>
                </View>
              </View>
            </View>
            <View
              style={{
                flexDirection: "row",
                paddingBottom: 2,
                marginBottom: 2,
              }}
            >
              {/* H.M.'s Mobile No. */}
              <View
                style={{
                  width: "20%",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  gap: 4,
                }}
              >
                <View style={{ width: "55%" }}>
                  <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                    H.M.'s Mobile No.
                  </Text>
                </View>
                <View
                  style={{
                    borderBottomWidth: 1,
                    borderColor: "black",
                    width: "40%",
                  }}
                >
                  <Text style={{ fontSize: 10 }}>
                    {schooldata.HEAD_MOBILE_NO}
                  </Text>
                </View>
              </View>

              {/* Email Id. */}
              <View
                style={{
                  width: "35%",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  gap: 4,
                }}
              >
                <View style={{ width: "15%" }}>
                  <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                    Email Id.
                  </Text>
                </View>
                <View
                  style={{
                    borderBottomWidth: 1,
                    borderColor: "black",
                    width: "80%",
                  }}
                >
                  <Text style={{ fontSize: 10 }}>
                    {schooldata.EMAIL_ADDRESS}
                  </Text>
                </View>
              </View>

              {/* Telephone No. */}
              <View
                style={{
                  width: "20%",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  gap: 4,
                }}
              >
                <View style={{ width: "45%" }}>
                  <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                    Telephone No.
                  </Text>
                </View>
                <View
                  style={{
                    borderBottomWidth: 1,
                    borderColor: "black",
                    width: "50%",
                  }}
                >
                  <Text style={{ fontSize: 10 }}>
                    {schooldata.TELEPHONE_NO || ""}
                  </Text>
                </View>
              </View>
              <View
                style={{
                  width: "25%",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  gap: 4,
                }}
              >
                <View style={{ width: "58%" }}>
                  <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                    Asstt. H.M.'s Mobile No :
                  </Text>
                </View>
                <View
                  style={{
                    borderBottomWidth: 1,
                    borderColor: "black",
                    width: "37%",
                  }}
                >
                  <Text style={{ fontSize: 10 }}>
                    {schooldata.ASSTISTENCE_TEACHER_CONTACT || " "}
                  </Text>
                </View>
              </View>
            </View>

            <View
              style={{
                marginTop: 10,
                fontSize: 5,
                borderLeft: "1px solid black",
                borderRight: "1px solid black",
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#f0f0f0",
                  borderTop: "1px solid black",
                  borderBottom: "1px solid black",
                }}
              >
                {[
                  "Sl No.",
                  "Student ID",
                  "Candidate Name",
                  "Challan No",
                  "Father's Name",
                  "Mother's Name",
                  "DOB",
                  "Caste",
                  "Category",
                  "Gender",
                  "Stream",
                  "SUBJECT 1A",
                  "SUBJECT 1B",
                  "SUBJECT 2",
                  "SUBJECT 3",
                  "SUBJECT 4",
                  "SUBJECT 5",
                  "SUBJECT 6",
                ].map((header, index, arr) => (
                  <Text
                    key={index}
                    style={{
                      flex: 1,
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: 6,
                      padding: 2,
                      borderRight:
                        index !== arr.length - 1 ? "1px solid black" : "none",
                    }}
                  >
                    {header}
                  </Text>
                ))}
              </View>
              {full_data.map((record, rowIndex) => (
                <View
                  key={rowIndex}
                  wrap={false}
                  style={{
                    flexDirection: "row",
                    borderBottom: "1px solid black",
                  }}
                >
                  {[
                    rowIndex + 1,
                    record.CANDIDATE_ID,
                    record.CANDIDATE_NAME,
                    record.CHALLAN_NO,
                    record.FATHER_NAME,
                    record.MOTHER_NAME,
                    record.DOB,
                    record.CASTE_NAME,
                    record.STUDENT_EXAM_SUB_CATEGORY.slice(0, 1).toUpperCase(),
                    record.GENDER.slice(0, 1).toUpperCase(),
                    record.STREAM,
                    record.SUBJECT_1_A,
                    record.SUBJECT_1_B,
                    record.SUBJECT_2,
                    record.SUBJECT_3,
                    record.SUBJECT_4,
                    record.SUBJECT_5,
                    record.SUBJECT_6,
                  ].map((item, colIndex, arr) => (
                    <Text
                      key={colIndex}
                      style={{
                        flex: 1,
                        textAlign: "center",
                        fontSize: 5,
                        padding: 2,
                        borderRight:
                          colIndex !== arr.length - 1
                            ? "1px solid black"
                            : "none",
                      }}
                    >
                      {item || "-"}
                    </Text>
                  ))}
                </View>
              ))}
            </View>

            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: 50,
                fontSize: 8,
              }}
            >
              <View>
                <Text>
                  i) Category : R = Regular, P = Private, Q = Qualifying
                </Text>
                <Text>ii) Gender : M = Male, F = Female, T = Transgender</Text>
                <Text>iii) Appearing in : ALL = All Subjects</Text>
              </View>
              <View>
                <Text>Paid by Challan No: {challanNo}</Text>
                <Text>
                  No of Candidate in the Challan: {summary_data.TOTAL}
                </Text>
              </View>
              <View style={{ marginRight: "50px" }}>
                <Text>Signature of Head of the Institution with Seal</Text>
              </View>
            </View>
            <View wrap={false}>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 10,
                  marginTop: "30px",
                }}
              >
                <Image
                  src="../assets/images/jac.png"
                  style={{
                    width: 35,
                    height: 35,
                    marginRight: 10,
                  }}
                />
                <View style={{ flex: 1, textAlign: "center" }}>
                  <Text style={{ fontSize: 12, fontWeight: "bold" }}>
                    JHARKHAND ACADEMIC COUNCIL, RANCHI
                  </Text>
                  <Text
                    style={{ marginTop: 4, fontSize: 10, fontWeight: "bold" }}
                  >
                    Summary Report Of Online Submitted Application For
                    Intermediate Examination 2026 (Annual)
                  </Text>
                </View>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  paddingBottom: 2,
                  marginBottom: 2,
                }}
              >
                <View
                  style={{
                    width: "20%",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    gap: 4,
                  }}
                >
                  <view style={{ width: "40%" }}>
                    <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                      School Code
                    </Text>
                  </view>
                  <View
                    style={{
                      borderBottomWidth: 1,
                      borderColor: "black",
                      width: "52%",
                    }}
                  >
                    <Text style={{ fontSize: 10, textAlign: "left" }}>
                      {schooldata.SCHOOL_CODE}
                    </Text>
                  </View>
                </View>

                <View
                  style={{
                    width: "40%",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    gap: 4,
                  }}
                >
                  <View style={{ width: "20%" }}>
                    <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                      School Name
                    </Text>
                  </View>
                  <View
                    style={{
                      borderBottomWidth: 1,
                      borderColor: "black",
                      width: "75%",
                    }}
                  >
                    <Text style={{ fontSize: 10, textAlign: "left" }}>
                      {schooldata.SCHOOL_NAME}
                    </Text>
                  </View>
                </View>

                <View
                  style={{
                    width: "20%",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    gap: 4,
                  }}
                >
                  <View style={{ width: "25%" }}>
                    <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                      District
                    </Text>
                  </View>
                  <View
                    style={{
                      borderBottomWidth: 1,
                      borderColor: "black",
                      width: "70%",
                    }}
                  >
                    <Text style={{ fontSize: 10, textAlign: "left" }}>
                      {schooldata.DISTRICT}
                    </Text>
                  </View>
                </View>
                <View
                  style={{
                    width: "20%",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    gap: 4,
                  }}
                >
                  <View style={{ width: "30%" }}>
                    <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                      Category
                    </Text>
                  </View>
                  <View
                    style={{
                      borderBottomWidth: 1,
                      borderColor: "black",
                      width: "65%",
                    }}
                  >
                    <Text style={{ fontSize: 10, textAlign: "left" }}>
                      {schooldata.CATEGORY || " "}
                    </Text>
                  </View>
                </View>
              </View>

              <View
                style={{
                  flexDirection: "row",
                  paddingBottom: 2,
                  marginBottom: 2,
                }}
              >
                {/* Sub-Division */}
                <View
                  style={{
                    width: "20%",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    gap: 4,
                  }}
                >
                  <View style={{ width: "40%" }}>
                    <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                      Sub-Division
                    </Text>
                  </View>
                  <View
                    style={{
                      borderBottomWidth: 1,
                      borderColor: "black",
                      width: "55%",
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>
                      {schooldata.DIVISION_NAME}
                    </Text>
                  </View>
                </View>

                {/* Block */}
                <View
                  style={{
                    width: "40%",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    gap: 4,
                  }}
                >
                  <View style={{ width: "10%" }}>
                    <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                      Block
                    </Text>
                  </View>
                  <View
                    style={{
                      borderBottomWidth: 1,
                      borderColor: "black",
                      width: "85%",
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>
                      {schooldata.BLOCK_NAME}
                    </Text>
                  </View>
                </View>

                {/* Post Office */}
                <View
                  style={{
                    width: "20%",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    gap: 4,
                  }}
                >
                  <View style={{ width: "35%" }}>
                    <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                      Post Office
                    </Text>
                  </View>
                  <View
                    style={{
                      borderBottomWidth: 1,
                      borderColor: "black",
                      width: "60%",
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>
                      {schooldata.POST_OFFICE}
                    </Text>
                  </View>
                </View>

                {/* PIN */}
                <View
                  style={{
                    width: "20%",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    gap: 4,
                  }}
                >
                  <View style={{ width: "20%" }}>
                    <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                      PIN
                    </Text>
                  </View>
                  <View
                    style={{
                      borderBottomWidth: 1,
                      borderColor: "black",
                      width: "75%",
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>
                      {schooldata.PIN_CODE || " "}
                    </Text>
                  </View>
                </View>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  paddingBottom: 2,
                  marginBottom: 2,
                }}
              >
                {/* H.M.'s Mobile No. */}
                <View
                  style={{
                    width: "20%",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    gap: 4,
                  }}
                >
                  <View style={{ width: "55%" }}>
                    <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                      H.M.'s Mobile No.
                    </Text>
                  </View>
                  <View
                    style={{
                      borderBottomWidth: 1,
                      borderColor: "black",
                      width: "40%",
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>
                      {schooldata.HEAD_MOBILE_NO}
                    </Text>
                  </View>
                </View>

                {/* Email Id. */}
                <View
                  style={{
                    width: "35%",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    gap: 4,
                  }}
                >
                  <View style={{ width: "15%" }}>
                    <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                      Email Id.
                    </Text>
                  </View>
                  <View
                    style={{
                      borderBottomWidth: 1,
                      borderColor: "black",
                      width: "80%",
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>
                      {schooldata.EMAIL_ADDRESS}
                    </Text>
                  </View>
                </View>

                {/* Telephone No. */}
                <View
                  style={{
                    width: "20%",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    gap: 4,
                  }}
                >
                  <View style={{ width: "45%" }}>
                    <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                      Telephone No.
                    </Text>
                  </View>
                  <View
                    style={{
                      borderBottomWidth: 1,
                      borderColor: "black",
                      width: "50%",
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>
                      {schooldata.TELEPHONE_NO || ""}
                    </Text>
                  </View>
                </View>
                <View
                  style={{
                    width: "25%",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    gap: 4,
                  }}
                >
                  <View style={{ width: "58%" }}>
                    <Text style={{ fontSize: 10, fontWeight: "bold" }}>
                      Asstt. H.M.'s Mobile No :
                    </Text>
                  </View>
                  <View
                    style={{
                      borderBottomWidth: 1,
                      borderColor: "black",
                      width: "37%",
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>
                      {schooldata.ASSTISTENCE_TEACHER_CONTACT || " "}
                    </Text>
                  </View>
                </View>
                {/* <View style={{ width: "20%" }}>
              <Text style={{ fontSize: 10 }}>
                <Text style={{ fontWeight: "bold" }}>
                  Asstt. H.M.'s Mobile No :
                </Text>
                <Text style={{ textDecoration: "underline" }}>
                  {schooldata.ASSTISTENCE_TEACHER_CONTACT || " "}
                </Text>
              </Text>
            </View> */}
              </View>

              <View
                style={{ marginTop: 10, marginHorizontal: 220, fontSize: 7 }}
                wrap={false}
              >
                {/* Table Header */}
                <View
                  style={{ flexDirection: "row", backgroundColor: "#f0f0f0" }}
                >
                  {tableHeaders.map((header, index) => (
                    <Text
                      key={index}
                      style={{
                        flex: 1,
                        fontWeight: "bold",
                        textAlign: "center",
                        fontSize: 7,
                        borderLeftWidth: 1,
                        borderTopWidth: 1,
                        borderBottomWidth: 1,
                        borderRightWidth: 1,
                        borderColor: "black",
                        padding: 2,
                      }}
                    >
                      {header === "GENDER" ? "Gender" : header}
                    </Text>
                  ))}
                </View>

                {/* Data Rows */}
                {filteredGenderRows.map((row, rowIndex) => (
                  <View key={rowIndex} style={{ flexDirection: "row" }}>
                    <Text
                      style={{
                        flex: 1,
                        textAlign: "center",
                        fontSize: 7,
                        borderLeftWidth: 1,
                        borderBottomWidth: 1,
                        borderRightWidth: 1,
                        borderColor: "black",
                        padding: 2,
                      }}
                    >
                      {row.GENDER}
                    </Text>

                    {availableColumns.map((col, colIndex) => (
                      <Text
                        key={colIndex}
                        style={{
                          flex: 1,
                          textAlign: "center",
                          fontSize: 7,
                          borderLeftWidth: 1,
                          borderBottomWidth: 1,
                          borderRightWidth: 1,
                          borderColor: "black",
                          padding: 2,
                        }}
                      >
                        {row[col] || "-"}
                      </Text>
                    ))}

                    <Text
                      style={{
                        flex: 1,
                        textAlign: "center",
                        fontSize: 7,
                        borderLeftWidth: 1,
                        borderBottomWidth: 1,
                        borderRightWidth: 1,
                        borderColor: "black",
                        padding: 2,
                      }}
                    >
                      {(row.EX_REGULAR || 0) +
                        (row.REGULAR || 0) +
                        (row.BETTERMENT || 0) +
                        (row.QUALIFYING || 0) +
                        (row.PRIVATE || 0)}
                    </Text>
                  </View>
                ))}

                {/* TOTAL Row */}
                {filteredGenderRows.length > 0 && (
                  <View style={{ flexDirection: "row" }}>
                    <Text
                      style={{
                        flex: 1,
                        textAlign: "center",
                        fontSize: 7,
                        fontWeight: "bold",
                        borderLeftWidth: 1,
                        borderBottomWidth: 1,
                        borderRightWidth: 1,
                        borderColor: "black",
                        padding: 2,
                      }}
                    >
                      TOTAL
                    </Text>

                    {availableColumns.map((col, colIndex) => (
                      <Text
                        key={colIndex}
                        style={{
                          flex: 1,
                          textAlign: "center",
                          fontSize: 7,
                          borderLeftWidth: 1,
                          borderBottomWidth: 1,
                          borderRightWidth: 1,
                          borderColor: "black",
                          padding: 2,
                        }}
                      >
                        {summary_data[col]}
                      </Text>
                    ))}

                    <Text
                      style={{
                        flex: 1,
                        textAlign: "center",
                        fontSize: 7,
                        borderLeftWidth: 1,
                        borderBottomWidth: 1,
                        borderRightWidth: 1,
                        borderColor: "black",
                        padding: 2,
                      }}
                    >
                      {summary_data.TOTAL}
                    </Text>
                  </View>
                )}
              </View>
            </View>
          </Page>
        );
      }
    )}
  </Document>
);
const ListofExamineesPDF12 = () => {
  const [groupedData, setGroupedData] = useState(null);
  const [schooldata, setSchooldata] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const token = sessionStorage.getItem("tokenclassxii");
      if (!token) {
        console.error("Missing token");
        setLoading(false);
        return;
      }

      try {
        const resp = await axios.get(
          `${config.API_BASE_URL}/ListOfExamineesCL12`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setGroupedData(resp.data.data.examinees_data);
        setSchooldata(resp.data.data.school_data);
      } catch (err) {
        console.error("Error fetching:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  // Show fullscreen loader
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "24px",
          fontWeight: "bold",
          color: "#333",
          backgroundColor: "#fff",
        }}
      >
        Loading...
      </div>
    );
  }

  // No data fallback
  if (!groupedData || !schooldata) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "20px",
          color: "#555",
        }}
      >
        No data available
      </div>
    );
  }

  // PDF Render
  return (
    <PDFViewer style={{ width: "100vw", height: "100vh" }}>
      <PdfReport groupedData={groupedData} schooldata={schooldata} />
    </PDFViewer>
  );
};

export default ListofExamineesPDF12;
